// import { COLORS } from '../../constants';

// eslint-disable-next-line no-unused-vars
const styles = theme => {
  // take mobile-first approach to do the styling

  const minSm = theme.breakpoints.up('sm');
  // const minMd = theme.breakpoints.up('md');

  return {
    wrapper: {
      [minSm]: {
        display: 'flex',
      },
    },
    main: {
      marginTop: 56,
      [minSm]: {
        marginTop: 64,
        marginLeft: 200,
        width: 'calc(100vw - 200px)',
      },
    },
    sidebar: {
      display: 'none',
      [minSm]: {
        display: 'block',
        position: 'fixed',
        top: 64,
        left: 0,
        width: 200,
        height: 'calc(100vh - 64px)',
      },
    },
  };
};

export default styles;
